import { xtwhUrls } from '@shared/urls/xtwhUrls';
import { Component, ViewChild, OnInit, Renderer2, ElementRef } from '@angular/core';
import { SettingsService } from '@delon/theme';
import { CacheService } from '@delon/cache';
import { fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { XtwhRequestService } from 'src/app/routes/teacher/xtwh/xtwhRequest.service';
import { NzMessageService } from 'ng-zorro-antd';
import { ReuseTabService } from '@delon/abc';

@Component({
    selector: 'layout-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.less'],
})
export class HeaderComponent implements OnInit {
    logoUrl = '';
    smallLogoUrl = '';
    lHidden = true;
    rHidden = true;
    isShowBtn = false;
    step = 95;
    leftPostion = 50;

    @ViewChild('navContainer', { static: true }) navContainer: any;
    @ViewChild('myNav', { static: true }) myNav: any;

    constructor(
        private el: ElementRef,
        public settings: SettingsService,
        public cacheService: CacheService,
        private request: XtwhRequestService,
        private msg: NzMessageService,
        private render: Renderer2,
        private reuseSrv: ReuseTabService,
    ) { }

    toggleCollapsedSidebar() {
        this.settings.setLayout('collapsed', !this.settings.layout.collapsed);
    }

    queryLogoInfo() {
        this.request.queryHomePageInfo().subscribe((res: any) => {
            if (res.err_code === 2000) {
                this.logoUrl = xtwhUrls.files.downloadFile_icon + `?fileName=${res.entity.logoimg}`;
                this.smallLogoUrl = xtwhUrls.files.downloadFile_icon + `?fileName=${res.entity.smalllogo}`;
            } else {
                this.msg.error(res.err_msg);
            }
        });
    }

    toRight() {
        this.leftPostion -= this.step;
        // 最右
        const maxRight = -(this.myNav.el.nativeElement.clientWidth - this.navContainer.nativeElement.clientWidth + 50);
        if (this.leftPostion <= maxRight) {
            this.leftPostion = maxRight;
        }
        this.render.setStyle(this.myNav.el.nativeElement, 'left', `${this.leftPostion}px`);
    }

    toLeft() {
        this.leftPostion += this.step;
        if (this.leftPostion >= 50) {
            this.leftPostion = 50;
        }
        this.render.setStyle(this.myNav.el.nativeElement, 'left', `${this.leftPostion}px`);
    }

    onSus(msg: string) {
        setTimeout(() => {
            const navContainerWidth = this.navContainer.nativeElement.clientWidth;
            const myNav = this.myNav.el.nativeElement;
            const myNavWidth = this.myNav.el.nativeElement.clientWidth;
            if (myNavWidth >= navContainerWidth - 100) {
                this.isShowBtn = true;
                this.render.setStyle(myNav, 'position', 'absolute');
                this.render.setStyle(myNav, 'left', `${this.leftPostion}px`);
            } else {
                this.isShowBtn = false;
                this.render.setStyle(myNav, 'position', 'static');
            }
        }, 1);
    }

    ngOnInit() {
        this.queryLogoInfo();
        fromEvent(window, 'resize')
            .pipe(debounceTime(500))
            .subscribe(e => {
                const navContainerWidth = this.navContainer.nativeElement.clientWidth;
                const myNav = this.myNav.el.nativeElement;
                const myNavWidth = this.myNav.el.nativeElement.clientWidth;
                if (myNavWidth >= navContainerWidth - 100) {
                    this.isShowBtn = true;
                    this.render.setStyle(myNav, 'position', 'absolute');
                    this.render.setStyle(myNav, 'left', `${this.leftPostion}px`);
                } else {
                    this.isShowBtn = false;
                    this.render.setStyle(myNav, 'position', 'static');
                }
            });
    }
}
